// Generated by design/logo/generate.py: the shapes of the S. The first number picks the colour, --sd-logo-<n>.
export const LOGO_BOX = '190 192 451 683';

export const LOGO_PATHS: [number, string][] = [
    [1, 'M538 193L415 193A224 224 0 0 0 318.76 214.73L350.55 281.55A150 150 0 0 1 415 267L538 267A37 37 0 0 0 538 193Z'],
    [2, 'M319.63 214.32A224 224 0 0 0 201.67 348.69L272.14 371.26A150 150 0 0 1 351.13 281.28Z'],
    [3, 'M201.96 347.78A224 224 0 0 0 219.17 525.75L283.86 489.82A150 150 0 0 1 272.34 370.65Z'],
    [4, 'M218.71 524.91A224 224 0 0 0 360.22 634.2L378.32 562.45A150 150 0 0 1 283.55 489.26Z'],
    [5, 'M359.29 633.96A224 224 0 0 0 415 641A11 11 0 0 1 415 663L296 663A37 37 0 0 0 296 737L415 737A85 85 0 0 0 415 567A150 150 0 0 1 377.7 562.29Z'],
    [1, 'M538 330L418 330A87 87 0 0 0 418 504A148 148 0 0 1 473.08 514.63L500.62 445.94A222 222 0 0 0 418 430A13 13 0 0 1 418 404L538 404A37 37 0 0 0 538 330Z'],
    [2, 'M472.48 514.39A148 148 0 0 1 558.95 606.87L629.43 584.31A222 222 0 0 0 499.72 445.59Z'],
    [3, 'M558.76 606.27A148 148 0 0 1 542.62 731.84L604.92 771.76A222 222 0 0 0 629.13 583.4Z'],
    [4, 'M542.96 731.3A148 148 0 0 1 445.1 797.5L458.66 870.25A222 222 0 0 0 605.44 770.95Z'],
    [5, 'M445.73 797.38A148 148 0 0 1 418 800L296 800A37 37 0 0 0 296 874L418 874A222 222 0 0 0 459.6 870.07Z'],
];
